import { Globe, Check } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";

const flagSrc = (code) => `https://flagcdn.com/w40/${code}.png`;

export default function LanguageSwitcher() {
  const { lang, setLang, langs } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = langs.find((l) => l.code === lang) || langs[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="language-switcher-button"
        className="flex items-center gap-2 px-3 py-2 rounded-full border border-white/10 hover:border-[var(--gold)]/50 transition-colors text-sm text-white/85"
      >
        <Globe size={16} className="text-[var(--brand-blue-bright)]" />
        <img src={flagSrc(current.flag)} alt={current.code} className="w-5 h-3.5 rounded-sm object-cover" />
        <span className="hidden sm:inline uppercase tracking-wider text-xs font-semibold">{current.code}</span>
      </button>

      {open && (
        <div
          data-testid="language-dropdown"
          className="absolute right-0 mt-2 w-56 glass rounded-xl shadow-2xl py-2 z-50 fade-in"
        >
          {langs.map((l) => (
            <button
              key={l.code}
              data-testid={`language-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-white/5 transition text-sm"
            >
              <span className="flex items-center gap-3">
                <img src={flagSrc(l.flag)} alt={l.code} className="w-6 h-4 rounded-sm object-cover" />
                <span className="text-white/90">{l.label}</span>
              </span>
              {lang === l.code && <Check size={14} className="text-[var(--gold)]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
